import { NgOptimizedImage } from "@angular/common";
import {
  Component,
  DOCUMENT,
  inject,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Router, RouterLink, RouterModule } from "@angular/router";
import { scrollToSection } from "../../utils/scroll-to";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule, RouterLink, NgOptimizedImage],
})
export class HeaderComponent {
  readonly #document = inject(DOCUMENT);
  readonly #router = inject(Router);
  #isClosed = true;
  public toggleNavbarButton(): void {
    this.#isClosed = !this.#isClosed;
    this.toggleNoScrollClass(this.#isClosed ? "remove" : "add");
  }

  public closeAndScrollTo(id?: string): void {
    if (!this.#isClosed) {
      this.removeOpenNavbarClasses();
    }
    if (id) {
      if (this.isMainPage()) {
        scrollToSection(id);
      } else {
        this.goToMainPageAndScrollTo(id);
      }
    }
  }

  private toggleNoScrollClass(action: "add" | "remove"): void {
    const { body, documentElement: html } = this.#document;

    if (action === "add") {
      body.classList.add("no-scroll");
      html?.classList.add("no-scroll");
    } else {
      body.classList.remove("no-scroll");
      html?.classList.remove("no-scroll");
    }
  }

  private removeOpenNavbarClasses(): void {
    const navbar = this.#document.querySelector("#navbarNavDropdown");
    const navbarButton = this.#document.querySelector("#navbarNavButton");

    this.#isClosed = !this.#isClosed;
    navbar?.classList.remove("show");
    navbarButton?.classList.add("collapsed");
    this.toggleNoScrollClass("remove");
  }

  isMainPage(): boolean {
    return this.#router.url === "/";
  }

  private goToMainPageAndScrollTo(id: string) {
    this.#router.navigate(["/"]);
    setTimeout(() => {
      scrollToSection(id);
    }, 1);
  }

  protected readonly scrollToSection = scrollToSection;
}
